import { InfoWrapper } from 'app/components';
import styles from '../CreateNotificationModal.module.scss';
import { useTranslation } from 'react-i18next';
import { Input } from 'app/components';

import { NotificationRuleSettingsT } from 'app/types/types';
import { AccessorAndParent } from '../../NotificationsPage';
import { AreaInField } from 'app/components/FilterPanel/AreaInField';
import { PortInField } from 'app/components/FilterPanel/PortInField';
import { VesselField } from 'app/components/FilterPanel/VesselField';

export const RuleForAVessel = ({
  errors,
  isAnyCheckedState,
  onComboBoxChange,
  settings,
  isFleetCheckedState,
}: NotificationRuleSettingsT<any>) => {
  const { t } = useTranslation();
  const [isAnyChecked, setIsAnyChecked] = isAnyCheckedState;
  const [isFleetChecked, setIsFleetChecked] = isFleetCheckedState;

  return (
    <div className={styles.row}>
      <div className={styles.row_title}>{t('Vessel')}:</div>
      {settings.accessor !== AccessorAndParent.TargetSafety && (
        <InfoWrapper
          label={`${t('MMSI')}:`}
          value={
            <div className={styles.row_item}>
              <VesselField fieldName={'mmsi'} onSelect={onComboBoxChange} />

              {errors.mmsi && <div className={styles.error_message}>{t(errors.mmsi)}</div>}
            </div>
          }
        />
      )}
      {settings.accessor !== AccessorAndParent.Anchorage && settings.accessor !== AccessorAndParent.TargetSafety && (
        <>
          <div className={styles.row_title}>{settings.accessor === 'port' ? t('Port') : t('Area')}:</div>
          <Input
            label={settings.accessor === 'port' ? t('AnyPort') : t('AnyArea')}
            name={settings.acessor}
            type="radio"
            value=""
            onChange={() => setIsAnyChecked(true)}
            checked={isAnyChecked}
          />

          <InfoWrapper
            label={
              <Input
                label={(settings.accessor === 'port' ? t('SpecifiedPort') : t('SpecifiedArea')) + ':'}
                name={`${settings.accessor + '_combobox'}`}
                type="radio"
                value=""
                onChange={() => setIsAnyChecked(false)}
                checked={!isAnyChecked}
              />
            }
            value={
              <div className={styles.row_item}>
                {settings.accessor === 'port' ? (
                  <PortInField fieldName="port" onSelect={onComboBoxChange} />
                ) : (
                  <AreaInField fieldName="area" onSelect={onComboBoxChange} />
                )}
                {!isAnyChecked && errors[settings.accessor] && (
                  <div className={styles.error_message}>{t(errors[settings.accessor])}</div>
                )}
              </div>
            }
          />
        </>
      )}
      {settings.accessor === AccessorAndParent.TargetSafety && (
        <>
          <Input
            label={t('FleetLabel')}
            name={settings.acessor}
            type="radio"
            value=""
            onChange={() => setIsFleetChecked(true)}
            checked={isFleetChecked}
          />
          <InfoWrapper
            label={
              <Input
                label={t('ChosenVessel')}
                name={`${settings.accessor + '_combobox'}`}
                type="radio"
                value=""
                onChange={() => setIsFleetChecked(false)}
                checked={!isFleetChecked}
              />
            }
            value={
              <div className={styles.row_item}>
                <VesselField fieldName={'mmsi'} onSelect={onComboBoxChange} />
              </div>
            }
          />
        </>
      )}
    </div>
  );
};
